<div *ngIf="loading">
    <div class="loader is-active padding-leader-3 padding-trailer-3">
        <div class="loader-bars"></div>
        <div class="loader-text">Loading Unshare Component...</div>
    </div>
</div>

<div *ngIf="!loading">
    <div *ngIf="layerTitle.length > 0" class="layer-title">
        <strong>{{ layerTitle }}&nbsp;-&nbsp;{{ layerId }}</strong>
        <hr>
    </div>
    <div class="flow shared">
        <div class="shareLabel">Shared:&nbsp;</div>
        <div *ngIf="shared[0]" class="recipientList field right">
            <table cellspacing="0">
                <tr *ngFor="let user of shared; let i = index">
                    <td>{{ user.firstName }}&nbsp;{{ user.lastName }}:</td>
                    <td>{{ user.email }}</td>
                    <td><i class="icon-ui-close-circled remove" (click)="unshareUser(i)"></i></td>
                </tr>
            </table>
        </div>
        <p class="field right" *ngIf="!shared[0]">None</p>
    </div>
    <hr>
    <div class="flow unshared">
        <div class="shareLabel">Remove:&nbsp;</div>
        <div *ngIf="unshared[0]" class="recipientList field right">
            <table cellspacing="0">
                <tr *ngFor="let user of unshared; let i = index">
                    <td>{{ user.firstName }}&nbsp;{{ user.lastName }}:</td>
                    <td>{{ user.email }}</td>
                    <td><i class="icon-ui-close-circled remove" (click)="undoUnshare(i)"></i></td>
                </tr>
            </table>
        </div>
        <p class="field right" *ngIf="!unshared[0]">None</p>
    </div>
    <hr>
    <div class="buttons flow">
        <div class="status left">
            <div *ngIf="unsharingLayer">
                <span class="k-i-loading"></span>
                <div class="shareMessage">Unsharing Layer...</div>
            </div>
            <div *ngIf="successMessage" class="center">
                <i class="icon-ui-check-mark">Layer successfully unshared</i>
            </div>
            <div *ngIf="failureMessage" class="center">
                <i class="icon-ui-close icon-ui-red">There was a problem unsharing your layer. Please try again.</i>
            </div>
        </div>
        <button kendoButton class="right unshareButton" (click)="unshareLayer()" [primary]="true" [disabled]="!unshared[0]">
            Unshare
        </button>
        <button kendoButton class="right cancelButton" (click)="resetAndClose()">Cancel</button>
    </div>
</div>
